import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button as AntButton, Modal, ModalProps, Select } from 'antd';
import { TEST_CENTER_HOST } from '../../../../lib/urls';
import styled from 'styled-components';
import { IExamCheckGetUrl, IExamCheckStart } from '../../../../models/testCenter.model';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/rootReducer';

interface IProps
  extends Pick<ModalProps, 'visible' | 'onCancel' | 'onOk'>,
  ICheckTypeProp,
  IExamCheckStart { }

interface ICheckTypeProp {
  setCheckType: (checkType: string) => void;
  checkType2: string | undefined;
}

const Block = styled.div`
  .font {
    color: #b8106f;
    font-size: 13px;
    font-weight: 600;
    margin-left: 33rem;
  }
  .onOkBtn {
    margin-left: 2rem;
  }
`;

const { Option } = Select;

const InspectionModal: FC<IProps> = ({
  certifyKey,
  checkType2,
  visible,
  onCancel,
  onOk,
  setCheckType,
  ...examCheckStart
}) => {
  const { t } = useTranslation();
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  const TE0009 = commonCodes.find(item => item.commonCode === 'TE0009')?.detailCode;

  const getURL = ({
    examTestCode,
    memberCode,
    examType,
    adminMode,
  }: Omit<IExamCheckGetUrl, 'certifyKey'>): string =>
    `${TEST_CENTER_HOST}/start-test?examTestCode=${examTestCode}&memberCode=${memberCode}&examType=${examType}&adminMode=${adminMode}`;

  return (
    <Modal
      title={`${t('cbt.test.button5')} - (${certifyKey})`}
      visible={visible}
      onCancel={onCancel}
      onOk={onOk}
      width={1350}
      footer={[
        <Block className='row'>
          <div className='font'>
            {t('cbt.test.7')}
            <Select
              className='w-110p ml-2'
              value={checkType2 ? checkType2 : 'TE'}
              onChange={(value) => setCheckType(value)}
            >
              {TE0009?.map(item => (
                <Option key={item.detailCode} value={item.detailCode}>
                  {item.korName}
                </Option>
              ))}
            </Select>
          </div>
          <div className="comm-btn__area justify-content-center onOkBtn">
            <AntButton key="submit" className='btn-basic pink' onClick={onOk}>
              {t('cbt.test.button6')}
             </AntButton>
          </div>
        </Block>
      ]}
    >
      <iframe
        title={t('cbt.test.8')}
        width={1280}
        height={800}
        src={getURL(examCheckStart)}
      />
    </Modal>
  );
};

export default InspectionModal;
